import { useState } from "react";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { useRemoveParticipationTemplateMutation } from "../../../api/hatimManagementApi";
import { useToast } from "../../../components/ui/Toast";
import { SoftButton, SoftRow, cls } from "../../hatim/soft/SoftKit";

export default function HatimParticipationList({ hatimTemplateId, codes }) {
  const { t } = useScriptMode();
  const toast = useToast();
  const [removeCode, { isLoading }] = useRemoveParticipationTemplateMutation();
  const [copiedCode, setCopiedCode] = useState(null);

  const list = Array.isArray(codes) ? codes : [];

  const handleCopy = async (code) => {
    try {
      await navigator.clipboard.writeText(code);
      setCopiedCode(code);
      setTimeout(() => setCopiedCode(null), 1500);
    } catch (_) {
      // ignore
    }
  };

  const handleRemove = async (code) => {
    try {
      await removeCode({ hatimTemplateId, code }).unwrap();
      toast.success(t("hatim_mgmt_participation_removed"));
    } catch (err) {
      const msg = err?.message || err?.data?.message || t("hatim_mgmt_action_error");
      toast.error(msg);
    }
  };

  if (list.length === 0) {
    return <p className={`text-sm px-4 py-4 ${cls.muted}`}>{t("hatim_mgmt_participation_empty")}</p>;
  }

  return (
    <ul className="tk-stagger">
      {list.map((c) => (
        <SoftRow
          key={c.code}
          avatar={<QrCode2Icon sx={{ fontSize: 18 }} aria-hidden />}
          title={<span className="font-mono tracking-wider">{c.code}</span>}
          meta={t("hatim_mgmt_participation_max_count_label").replace(/\{n\}/g, c.maxCount)}
          right={
            <div className="flex items-center gap-2 shrink-0">
              <SoftButton tone="soft" size="small" startIcon={<ContentCopyIcon fontSize="small" />} onClick={() => handleCopy(c.code)}>
                {copiedCode === c.code
                  ? t("hatim_mgmt_add_participation_copied")
                  : t("hatim_mgmt_add_participation_copy")}
              </SoftButton>
              <SoftButton
                tone="cancel"
                size="small"
                startIcon={<DeleteOutlineIcon fontSize="small" />}
                onClick={() => handleRemove(c.code)}
                disabled={isLoading}
              >
                {t("hatim_mgmt_remove_confirm_cta")}
              </SoftButton>
            </div>
          }
        />
      ))}
    </ul>
  );
}
